import { Modal } from "react-bootstrap"
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getOutletInformation } from "../../actions/autocompleteActions";
import { getCurrentOutlet, getOutlates, getStatusDeliveryStore } from "../../actions/productActions";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { Spinner, Toast } from "react-bootstrap";
import { getSelectedOutlet, checkIfRestDay } from "./outletFunctions";
import "../../assets/css/form.css"
import PopUp from "../Modals/Popup";
import "./Sidebar.css";

const OutletInfo = (props) => {

  const [numberOfOutlets, setNumberOfOutlets] = useState(0)
  const [statusOutlet, setStatusOutlet] = useState(false)
  const [statusPopUp, setStatusPopUp] = useState(false);

  const defaultData = {
    id: 0,
    name: ""
  }
  const [currentOutlet, selectOutlet] = useState({ //CURRENT OUTLET DATA USED TO KEEP TRACK WHEN USER CLICKS ON OUTLET
    ...defaultData
  });

  useEffect(() => {
    if (currentOutlet) {
      props.getCurrentOutlet(currentOutlet);
    }
  }, [currentOutlet]);

  // const getSelectedOutlet = (id) => { //RETURN DELIVERY CHARGE FOR SPECIFIC OUTLET VIA ID
  //   for (let i = 0; i < props?.postal?.outlet?.data.length; ++i){
  //     if (id === props?.postal?.outlet?.data[i].id) {
  //       return props?.postal?.outlet?.data[i].charges
  //     }
  //   }
  // }

  const changeDeliveryCharge = (outlet) => { //UPDATE DELIVERY FEES AND RESPECTIVE OUTLET INFORMATION

    if (outlet) {
      props.setDeliveryInformation({ //SET OUTLET INFORMATION USING THE SET STATE FUNCTION(SETOUTLET) FROM RIGHT-SIDEBAR.JS SO IT RENDERS THE NEW VALUE
        ...props.deliveryInformation,
        deliveryOutName: outlet.name,
        deliveryOutLat: outlet.lat,
        deliveryOutLong: outlet.lng,
        deliveryOutAddress: outlet.address,
        deliveryOutId: outlet.id,
        deliveryCharge: outlet.charges?.totalFee,
        deliveryCurrency: outlet.charges?.totalFeeCurrency,
        deliveryQuotationId: outlet.charges?.data?.quotationId,
        deliveryScheduleAt: outlet.charges?.data?.scheduleAt,
        deliveryExpiresAt: outlet.charges?.data?.expiresAt,
        deliveryStopIdOne: outlet.charges?.data?.stops[0].stopId,
        deliveryStopIdTwo: outlet.charges?.data?.stops[1].stopId
      })
    }
  }

  useEffect(() => {
    setStatusOutlet(props.outlet_status.result);
    if (props.outlet_status.result) {
      props.closeOutlet()
    } else {
      if (props.outlet_status.result != undefined && !props.postal?.loading) {
        setStatusPopUp(true);
      }
    }
  }, [props.outlet_status])

  const hideStatusOutletModal = () => {
    console.log(statusPopUp)
    setStatusPopUp(false);
  };

  useEffect(() => {
    // if (props?.postal?.outlet?.data[0]?.is_open && !checkIfRestDay(props?.postal?.outlet?.data[0]?.is_open)) {
    //   console.log(props?.postal?.outlet?.data[0])
    //   selectOutlet({ ...props.postal?.outlet?.data[0] })
    //   changeDeliveryCharge(props.postal?.outlet?.data[0])
    // }

    let numOfOut = 0 //RESET OUTLET NUMBER EVERYTIME OUTLET CHANGES
    let cdata = props?.outlets?.business_location;
    props.postal.outlet?.data?.forEach((outlet, index) => {
      if (outlet.is_open && !checkIfRestDay(outlet) && cdata[index]?.custom_field3 !== null) {
        numOfOut += 1
        setNumberOfOutlets(numOfOut)
      }
    })
  }, [props.postal.outlet]) //USED TO SEE IF USER HAS CHANGED HIS/HER ADDRESS. UPDATE THE DELIVERY CHARGE WITH THE NEW ONE BASED ON CURRENT SELECTED OUTLET

  const outletData = props?.postal?.outlet?.data || [];
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const todayDay = days[new Date().getDay()];

  const openOutlets = outletData?.filter((outlet) => {
    if (!outlet.is_open) return false;
    if (outlet?.custom_field3) {
      const isRestDay = outlet?.custom_field2?.includes(todayDay);
      if (isRestDay) return false;
    }
    return true;
  });
  
  const formatTime = (time) => {
    if (!time) return "";

    const [hourStr, minuteStr] = time.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    const postfix = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; 

    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${postfix}`;
  };

  const renderOutlets = () => {
    const outletData = props?.postal?.outlet?.data;

    // localStorage.setItem("amount_rounding_method",props?.getOutlates?.filter((outlet) => outlet.business_location.id === localStorage.getItem('location_id'))[0]?.amount_rounding_method || "none");

    const amount_rounding_method = props?.outlets?.business_location.filter((outlet) => outlet.id === parseInt(localStorage.getItem('location_id')))[0]?.amount_rounding_method || "none";
    
   localStorage.setItem("amount_rounding_method", amount_rounding_method);
   
    if (outletData) {
      const html = []; //LIST OF ITEMS(OUTLET INFORMATION) TO RENDER
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const today = (new Date()).getDay();
      openOutlets?.length > 0 ?
        (Object.keys(outletData)?.map((key, index) => {
          if (outletData[index]?.custom_field3) {
            const selectedOutlet = getSelectedOutlet(outletData[key].id, props.postal.outlet.data)
            html.push(
              <div
                key={index}
                style={(!outletData[index].is_open || checkIfRestDay(outletData[index])) ? {
                  pointerEvents: 'none',
                  'cursor': 'not-allowed',
                  'opacity': '0.4'
                } : {
                  pointerEvents: 'auto',
                  'cursor': 'pointer',
                  'opacity': '1'
                }}
                className={
                  currentOutlet.id === outletData[index].id ? "box fill" : "box outline"
                }
                onClick={(e) => {
                  changeDeliveryCharge(outletData[index])
                  selectOutlet({
                    ...outletData[index],
                    id: outletData[index].id,
                    name: outletData[index].name
                  })
                }}
              >
                <div className="ins">
                  <ul>
                    <li>
                      <span className="txt title">{outletData[key].name}</span>
                    </li>
                    <li>
                      <span className="txt">
                        {outletData[key].address}
                      </span>
                    </li>
                    {/* {outletData[key]?.custom_field2 ?
                      <li>
                        <span className="name">Rest day :</span>
                      </li>Rest day :
                      : ""
                    } */}
                    <li>
                      <span className="name">Hours :</span>
                      <span className="txt">
                        {" "}
                        <span className={outletData[key].is_open && !checkIfRestDay(outletData[key]) ? 'open' : 'outletClosed'}>
                          {outletData[key].is_open && !checkIfRestDay(outletData[key]) ? 'Open' : 'Close'}
                        </span>
                          {formatTime(outletData[key].open_time)} - {formatTime(outletData[key].close_time)}
                      </span>
                    </li>
                    <li>
                      <span className="name">Phone :</span>
                      <span className="txt bold">  {outletData[key].phone}</span>
                    </li>
                    {/* <li>
                      {outletData[key].is_open && !checkIfRestDay(outletData[key]) // Check if outlet is open, if yes show delivery charge and check if the user has entered an address. If outlet is not open, dont show delivery charge
                        ?
                        (<>
                          <span className="name">Delivery charge :</span>
                          <span className="txt bold" style={{ 'marginLeft': '10px' }} data-testid="delivery_charge">  {outletData[key]?.charges?.data?.priceBreakdown?.total ?? "-"}{" "} $</span>
                        </>) : ""
                      }
                    </li> */}
                  </ul>
                </div>
              </div>
            )
          }
        })) :
        html.push(
          <div className="ins no-outlets">
            Sorry, no stores are open right now.
          </div>
        )
      return html
    }
  }

  return (
    <div>
      <Modal
        show={props.showOutlet}
        onHide={props.closeOutlet}
        className="rounded-lg outlet-modal"
        dialogClassName="modal-md xs"
        contentClassName="pickup-modal xs modal_form"
        centered
        backdrop="static"
      >
        <Modal.Header className="no">
          <h4 className="modal-title">Outlets</h4>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={props.closeOutlet}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>

        <Modal.Body className="no">
          {props.postal?.loading ? (
            <div
              style={{
                minHeight: "120px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner animation="border" />
            </div>
          ) : outletData?.length > 0 ? (
            <>
              <div className="scroll">
                <div className="box data">
                  <div className="ins">
                    <span>{numberOfOutlets} Store(s) Available</span>
                  </div>
                </div>
              </div>
              {props.postal.outlet ? renderOutlets() : ""}
            </>
          ) : (
            <div className="text-center py-4 font-weight-bold ">
              Sorry, no outlets are available right now.
            </div>
          )}
        </Modal.Body>

        {!props.postal?.loading && outletData?.length > 0 && (
          <Modal.Footer
            style={{ borderTop: 0 }}
            className="modal-footer form-action"
          >
            <button
              type="button"
              className="btn lg primary d-block"
              style={
                numberOfOutlets === 0 || currentOutlet.id === 0
                  ? { pointerEvents: "none", opacity: 0.5 }
                  : {}
              }
              onClick={() => {
                props.getStatusDeliveryStore({
                  location_id: currentOutlet.id,
                });
              }}
            >
              Select Outlet
            </button>
          </Modal.Footer>
        )}
      </Modal>

      <Modal
        show={statusPopUp}
        onHide={hideStatusOutletModal}
        className="rounded-lg"
        dialogClassName="modal-md xs"
        contentClassName="pickup-modal xs modal_form status_delivery_modal"
        centered
        backdrop="static"
      >
        <Modal.Header className="no">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={hideStatusOutletModal}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body className="no">
          <div className="box data">
            <div className="ins">
              <span>This store is not available now.</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => ({
  postal: state.postal,
  outlets: state.products.outlates,
  outlet_status: state.products.outlet_status
});
export default withTranslation()(
  connect(mapStateToProps, { getOutletInformation, getOutlates, getStatusDeliveryStore, getCurrentOutlet })(
    OutletInfo
  )
);